export const DELETE_RECIPE_SCENARIOS = {
  NOTIFY: 1,
  ALLOW_SET_INACTIVE: 2,
};



// WEBPACK FOOTER //
// ./src/common/Components/RecipeTable/Constants.js